var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldMessageEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C4 2 2 4 2 8v13c0 .55.45 1 1 1h13c4 0 6-2 6-6V8c0-4-2-6-6-6H8zm2.06 15.19-2.08.29c-.08.01-.16.02-.23.02-.35 0-.67-.12-.9-.35-.28-.28-.4-.69-.33-1.13l.29-2.08c.05-.34.28-.81.53-1.05l3.77-3.77c.06.18.14.36.23.56.09.18.18.36.28.53.08.14.17.28.25.38.1.15.2.28.27.35.04.06.08.1.09.12.22.25.45.49.67.67.06.06.1.09.11.1.13.1.25.21.37.28.13.1.27.19.41.27.17.1.35.2.54.29.19.09.37.16.55.22l-3.77 3.77c-.25.25-.71.48-1.05.53zm5.71-5.18c-.05.05-.12.08-.19.08-.02 0-.06 0-.08-.01a5.238 5.238 0 0 1-3.58-3.58c-.03-.09 0-.19.07-.26l.79-.79c1.29-1.29 2.51-1.26 3.77 0 .64.64.96 1.26.95 1.9 0 .63-.31 1.24-.95 1.88l-.78.78z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMessageEdit);
export default __webpack_public_path__ + "static/media/vuesax-bold-message-edit.3adb3bc59acb9498f1563e63a178b4a6.svg";
export { ForwardRef as ReactComponent };